import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import { useFormik } from "formik";
import { STATUS_PROCESS } from "libs/configs/constant";
import { SMART_NAME } from "libs/constant/smartForm";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  getFieldRequired,
  getMinRequired,
  transformDocumentRequired,
  transformDocumentTopic
} from "libs/utils/uploadDocument";
import { get } from "lodash-es";
import mime from "mime";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addExtension,
  addWorkPermit,
  getSmartFormFieldConfig,
  selectDocumentRequired,
  selectReqdoclogList,
  selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function useUploadDocumentForm({
  isExtension,
  isChange,
  isLTR,
  isWorkPermit,
  canEdit,
  setSaveDraft,
  conditionPrivate,
  isSubmitPreapprove,
}) {
  const dispatch = useDispatch();
  const { showLoading } = useModalLoading();

  const { data: documentRequired } = useSelector(selectDocumentRequired);
  const { list: reqdoclogList } = useSelector(selectReqdoclogList);
  const { smartType, smartService } = useSmartService();

  const { fileDocument, draftId, addSmartForm, smartform, condition } =
    useSmartForm();
  const { personalId: personalID } = usePersonalDetail();
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(smartform, "detail", []).reduce(
    smartNameById,
    {}
  );
  const conditionType = get(smartformDetail, "ConditionType.value", "");
  const isConfirm = get(smartformDetail, "isConfirm.value", false);
  const isConfirmSmartId = get(smartformDetail, "isConfirm.smartId", "");
  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const isConfirmConfig = defaultType.filter(
    (v) => v.smartName === "isConfirm"
  );

  const smartserviceId = get(smartform, "smartserviceId");
  const smartserviceReferId = get(smartform, "smartserviceReferId");
  const currentSmart = get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceReferId
  );
  const smartserviceName = get(currentSmart, "smartserviceName", "");
  const statausID = get(smartform, "statausID", "");
  const smartTypeExtension = SMART_NAME[smartserviceName];

  const isDepartmentRequestDoc = statausID === STATUS_PROCESS.RequestAddDoc;
  const isPending = statausID === STATUS_PROCESS.Pending;
  const isDisabledRemoveButton = isDepartmentRequestDoc || isPending;

  useEffect(() => {
    if (smartserviceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartserviceId }));
    }
  }, [smartserviceId]);

  const getRemarkByConfigDocumentRequired = (id) =>
    (isDisabledRemoveButton ? reqdoclogList : [])
      .reduce((p, c) => {
        const listFilter = c.detail.filter(
          (v) => v.configDocumentRequiredID === id
        );
        if (listFilter.length > 0) {
          return [
            ...p,
            ...listFilter.reduce((pi, ci) => [...pi, ci.remark], []),
          ];
        }

        return p;
      }, [])
      .join(", ");

  const fieldRequired =
    isExtension || isChange
      ? "blank"
      : getFieldRequired(
        isExtension ? smartTypeExtension : smartType,
        conditionType
      );
  let fieldRequiredLTR = "blank";
  if (smartserviceId === "HSG") {
    fieldRequiredLTR = "blank";
  } else if (smartserviceId === "HSPC") {
    fieldRequiredLTR = conditionPrivate === "true" ? "government" : "company";
    // government
    // conditionPrivate === "true" ?  fieldRequiredLTR = "company" : ;
  }

  const rawDocuments = transformDocumentRequired(documentRequired);

  const allTocpic = transformDocumentTopic(rawDocuments);
  const documents = rawDocuments.map((v) => ({
    ...v,
    topic: v.topic.map((t) => ({
      ...t,
      remark: getRemarkByConfigDocumentRequired(t.configDocumentRequiredID),
    })),
  }));

  const callAPISubmit = async (values) => {
    const backlist = ["accep1"];
    const whitelistKey = Object.keys(values).filter(
      (v) => !backlist.includes(v)
    );
    const whitelistValue = whitelistKey
      .map((key) => values[key])
      .filter((v) => v.length > 0)
      .reduce((p, c) => [...p, ...c], []);

    const isConfirmConfigValue = isConfirmConfig.map((c) => ({
      ...c,
      smartId: isConfirmSmartId || null,
      value: values.accep1,
    }));

    const imageWithoutRemovedBeforeUpload = (value) =>
      !(value.status === false && !value.smartId);

    if (isExtension) {
      const prepareData = {
        draftId: smartform.draftId,
        draftIdRef: smartform.draftIdRef,
        smartserviceId: smartform.smartserviceId,
        smartserviceReferId: smartform.smartserviceReferId,
        personalId: personalID,
        detail: whitelistValue
          .map((value) => ({
            partfromId: null,
            configsmartId: null,
            linkTable: "",
            value: null,
            configConditionVisaId: null,
            // ---
            smartId: value.smartId || null,
            configDocumentRequiredID: value.configDocumentRequiredID,
            ocRtext: value.ocRtext || "",
            fileID: value.fileID || "",
            status: value.status !== undefined ? value.status : true,
          }))
          .concat(isConfirmConfigValue)
          .filter(imageWithoutRemovedBeforeUpload),
      };
      await dispatch(addExtension(prepareData));
    } else {
      const prepareData = {
        draftId: draftId || null,
        smartserviceId,
        personalId: personalID,
        detail: whitelistValue
          .map((value) => ({
            partfromId: null,
            configsmartId: null,
            linkTable: "",
            value: null,
            configConditionVisaId: null,
            // ---
            smartId: value.smartId || null,
            configDocumentRequiredID: value.configDocumentRequiredID,
            ocRtext: value.ocRtext || "",
            fileID: value.fileID || "",
            status: value.status !== undefined ? value.status : true,
            // isConfirm: value.accep1
          }))
          .concat(isConfirmConfigValue)
          .filter(imageWithoutRemovedBeforeUpload),
      };

      if (isWorkPermit) {
        await dispatch(addWorkPermit({ data: prepareData }))
      } else {
        await addSmartForm({
          data: prepareData,
        });
      }
    }
  };

  const validationSchema = yup.object({
    ...(canEdit
      ? allTocpic.reduce(
        (p, c, i) => ({
          ...p,
          [c.documentID]: yup
            .array()
            // .min(
            //   getMinRequired(c[fieldRequired]),
            //   `(${c.docIndex}) Document is required.`
            // )
            .test(
              "lengthFilter",
              `(${c.docIndex}) Document is required.`,
              (value) => {
                if (
                  getMinRequired(
                    c[isLTR ? fieldRequiredLTR : fieldRequired]
                  ) === 0
                )
                  return true;

                return value && value.filter((v) => v.status).length;
              }
            ),
        }),
        {}
      )
      : {}),
    accep1:
      canEdit && !isSubmitPreapprove
        ? yup.bool().oneOf([true], `Your never accept agreement`)
        : null,
  });
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      ...allTocpic.reduce(
        (p, c) => ({
          ...p,
          [c.documentID]: fileDocument
            .filter(
              (doc) =>
                doc.configDocumentRequiredID === c.configDocumentRequiredID
            )
            .map((doc) => ({
              ...doc,
              status: true,
              file: new File([new Blob()], `${doc.fileName}${doc.ext}`, {
                type: mime.getType(doc.ext),
              }),
            })),
        }),
        {}
      ),
      accep1: isConfirm,
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  const onSaveDraft = () => {
    setSaveDraft(true);
    callAPISubmit(formik.values);
  };

  return {
    personalID,
    documents,
    formik,
    condition,
    draftId,
    isDisabledRemoveButton,
    isDepartmentRequestDoc,
    reqdoclogList,
    onSaveDraft,
  };
}
